
import { BehaviorSubject } from "rxjs";
import { Injectable, Optional, SkipSelf } from "@angular/core";
import { Product, ProductDtls, ProductDtlsForReview } from "app/models/products.model";
import { UserProfileRecord } from "app/users/user-profile-record";
import { BillingAddress } from "app/models/customer.model";


@Injectable({
    providedIn: 'root'
  })

export class SharedDataService {
    
private products = new BehaviorSubject<Product[]>([]);
getProducts = this.products.asObservable();

private subscriptions = new BehaviorSubject<any>(null);
getSubscriptions = this.subscriptions.asObservable();


private quantity = new BehaviorSubject<number>(0);
getQuantity = this.quantity.asObservable();

private _userInfo!: UserProfileRecord;

private _ordNumber!: string;

private _ordReviewItems!: ProductDtlsForReview[];

private _promoCodes!: string[];

private _cartProducts!: [{[key: string]: ProductDtls}];

private _promoCodeForUpdate!: string;

private _userAddress!: Partial<BillingAddress>;

private _userCompany!: string;

constructor(@Optional() @SkipSelf() parentModule?: SharedDataService) {
    if (parentModule) {
      throw new Error(
        'SharedDataService is already loaded. Import it in the AppModule only');
    }
  }
  
  setSubscriptions(data: any) {
      this.subscriptions.next(data);  
  }

  setProducts(data: Product[]) {
    this.products.next(data);  
  }

  setReturnUrl(returnUrl: string) {
    this.set('returnUrl', returnUrl);
  }

  getReturnUrl() {
    let returnUrl = this.get('returnUrl');
    return !!returnUrl ? returnUrl : '';
  }

  setFlowId(flowId: string) {
    this.set('flowId', flowId);
  }

  getFlowId() {
    let flowId = this.get('flowId');
    return !!flowId ? flowId : '';
  }

  removeFlowId () {
     sessionStorage.removeItem('flowId');
  }

  private set (key: string, value: any) {
    sessionStorage.setItem(key, value);
  }

  private get(key: string) {
    return sessionStorage.getItem(key);
  }

  setQuantity(qnty: number) {
    this.quantity.next(qnty);
    if(qnty >= 0)
      this.set('quantity', qnty.toString());
    else 
      this.set('quantity', '0');
  }

  getQuantityFromLS(): number {
    return this.get('quantity') ? Number(this.get('quantity')) : 0;
  }

  get userInfo() {
    return this._userInfo
  }

  setUserInfo(user: UserProfileRecord) {
    this._userInfo = user;
    return this;
  }

  get orderNumber() {  
    if(!this._ordNumber) {
      let ordNbr = sessionStorage.getItem('orderNumber');
      return ordNbr ? ordNbr : '';
    }
    return this._ordNumber;
  }

  setOrderNumber(ordNumber: string, toDelete: boolean){
    this._ordNumber = ordNumber;
    if(!toDelete)
      this.set('orderNumber', ordNumber);
    else
      sessionStorage.removeItem('orderNumber');
    return this;
  }

  get orderReviewItems() {
    return this._ordReviewItems;
  }

  setOrderReviewItems(items: ProductDtlsForReview[], toDelete: boolean){
    this._ordReviewItems = items;
    if(!toDelete)
      this.set('reviewItems', JSON.stringify(items));
    else
      sessionStorage.removeItem('reviewItems');
    return this;
  }

  get promoCodes() {
    if (typeof this._promoCodes === "undefined") {
      return (sessionStorage.getItem("promoCodes")) ? JSON.parse(sessionStorage.getItem("promoCodes")+"") : [];
    } else {
      return this._promoCodes;
    }
  }

  setPromoCodes(codes: string[], toDelete: boolean){
    this._promoCodes = codes;
    if(!toDelete)
      this.set('promoCodes', JSON.stringify(codes));
    else
      sessionStorage.removeItem('promoCodes');
    return this;
  }
  
  get promoCodeForUpdate() {
    if (!this._promoCodeForUpdate) {
      return (sessionStorage.getItem("promoCodeForUpdate")) ? JSON.parse(sessionStorage.getItem("promoCodeForUpdate")+"") : '';
    } else {
      return this._promoCodeForUpdate;
    }
  }

  setPromoCodeForUpdate(code: string, toDelete: boolean){
    this._promoCodeForUpdate = code;
    if(!toDelete)
      this.set('promoCodeForUpdate', JSON.stringify(code));
    else
      sessionStorage.removeItem('promoCodeForUpdate');
    return this;
  }

  get cartProducts() {
    return this._cartProducts;
  }

  setCartProducts(prods: [{[key: string]: ProductDtls}], toDelete: boolean ){
    this._cartProducts = prods;
    if(!toDelete)
      this.set('cartProducts', JSON.stringify(prods));
    else
      sessionStorage.removeItem('cartProducts');
    return this;
  }

  setUserAddress(address: Partial<BillingAddress>){
    this._userAddress = address;
    this.set('address', JSON.stringify(address));
  }

  get userAddress() {
    if(!this._userAddress) {
      let addr = sessionStorage.getItem('address');
      return addr ? JSON.parse(addr) : '';
    }
    return this._userAddress;
  }

  get userCompany() {
    if (!this._userCompany) {
      let comp = sessionStorage.getItem('company');
      return comp ? comp : '';
    } else {
      return this._userCompany;
    }
  }

  setUserCompany(company: string){
    this._userCompany = company;
    this.set('company', company);
  }


}